import Seo from "@/components/seo/Seo";
import JsonLd from "@/components/seo/JsonLd";
import { breadcrumbLd } from "@/data/schema";
import { Cpu, Lock, ShieldOff, BadgeCheck, MessageSquareText, ScanLine } from "lucide-react";
import PageHero from "@/components/layout/PageHero";
import AIStack from "@/components/home/AIStack";
import CtaBand from "@/components/layout/CtaBand";
import Reveal from "@/components/ui/reveal";
import SectionHeading from "@/components/ui/section-heading";

const USE_CASES = [
    { icon: MessageSquareText, title: "AI Doradca", desc: "Pytasz po polsku „ile odłożyć na podatek?” — dostajesz konkretną kwotę z wyjaśnieniem, w kontekście Twojej firmy." },
    { icon: ScanLine, title: "OCR dokumentów", desc: "Zdjęcie faktury lub paragonu zamienia się w gotowy wpis: kwoty netto/brutto, stawki VAT, dane kontrahenta." },
    { icon: Cpu, title: "Propozycje księgowań", desc: "AI proponuje kwalifikację kosztu i wpis do KPiR. Ty jedynie zatwierdzasz jednym kliknięciem." },
];

const PRIVACY = [
    { icon: Lock, title: "Szyfrowanie i HMAC", desc: "Każde żądanie do modeli jest podpisane i szyfrowane. Dane w spoczynku również zaszyfrowane." },
    { icon: ShieldOff, title: "Zero trenowania", desc: "Twoje faktury i rozmowy nie są używane do trenowania modeli AI. Kropka." },
    { icon: BadgeCheck, title: "Zgodność z RODO", desc: "Przetwarzanie w UE, minimalizacja danych, prawo do wglądu i usunięcia." },
];

export default function AIPage() {
    return (
        <>
            <Seo
                title="AI"
                path="/ai"
                description="AI w Groszowniku: Claude Sonnet 4.5 do rozumowania i AI Doradcy oraz Gemini 2.5 Flash do OCR. Bezpiecznie — HMAC, zero trenowania na Twoich danych, RODO."
            />
            <JsonLd data={breadcrumbLd([{ name: "Start", path: "/" }, { name: "AI", path: "/ai" }])} />
            <PageHero
                eyebrow="Sztuczna inteligencja"
                title="AI, które rozumie polskie podatki"
                subtitle="Łączymy dwa najlepsze modele do konkretnych zadań i traktujemy Twoje dane jak świętość."
            />
            <AIStack />

            <section className="py-16 lg:py-24">
                <div className="container-gr">
                    <SectionHeading eyebrow="Zastosowania" title="Gdzie AI realnie oszczędza Ci czas" />
                    <div className="mt-12 grid gap-4 md:grid-cols-3">
                        {USE_CASES.map((u, i) => (
                            <Reveal key={u.title} delay={i * 0.06} className="rounded-2xl border border-border bg-card p-6">
                                <div className="grid h-12 w-12 place-items-center rounded-xl bg-gr-secondary text-gr-primary dark:bg-gr-dsecondary dark:text-gr-dprimary">
                                    <u.icon className="h-6 w-6" />
                                </div>
                                <h3 className="mt-5 text-xl tracking-tight text-foreground">{u.title}</h3>
                                <p className="mt-2 text-sm text-muted-foreground">{u.desc}</p>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>

            <section className="border-t border-border py-16 lg:py-24">
                <div className="container-gr">
                    <SectionHeading eyebrow="Prywatność" title="Twoje dane zostają Twoje" sub="Bez gwiazdek i drobnego druku — tak dbamy o bezpieczeństwo." />
                    <div className="mt-12 grid gap-4 md:grid-cols-3">
                        {PRIVACY.map((p, i) => (
                            <Reveal key={p.title} delay={i * 0.06} className="rounded-2xl border border-border bg-card p-6">
                                <p.icon className="h-6 w-6 text-gr-accent" />
                                <h3 className="mt-4 text-lg tracking-tight text-foreground">{p.title}</h3>
                                <p className="mt-2 text-sm text-muted-foreground">{p.desc}</p>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>
            <CtaBand title="Zaufaj AI, które gra do jednej bramki — Twojej" subtitle="Pobierz Groszownik i miej doradcę podatkowego w kieszeni." />
        </>
    );
}
